// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__fLcSs","modalFooterButton":"ModalNotes_modalFooterButton__GL-wC"};